import React from 'react'

import { NormalizedSubscriptionFeature } from 'src/user/fragments'
import RemainingRewards from '../subscriptions/RemainingRewards'

import styles from './feature.module.scss'

interface FeatureProps {
  feature: NormalizedSubscriptionFeature
}

const Feature: React.FC<FeatureProps> = ({
  feature: { label = '', remaining = 0, total = 0 },
}) => {
  if (remaining >= 0 && total > 0) {
    return (
      <RemainingRewards label={label} remaining={remaining} total={total} />
    )
  } else if (remaining >= 0) {
    return (
      <div className={styles.status} style={{ marginTop: 8 }}>
        <div className={styles.details}>
          <p>{label}</p>
          <p className={styles.amount}>{remaining}</p>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default Feature
